<template>
  <div class="container">
    <section class="content checkout-content">
      <div class="vendor-listing-section">
        <div class="product-display">
          <div class="product-image-a">
            <img
              :src="getSelectedProduct[0].product_details.images[0]"
              alt="Product Image"
              data-test="vendorListingPdtImg"
              id="vendorListingPdtImg"
            />
          </div>
          <div class="product-details">
            <p data-test="vendorListingPdtName"
															id="vendorListingPdtName">{{getSelectedProduct[0].product_name}}</p>
            <div
              v-if="getSelectedProduct[0].review && getSelectedProduct[0].review.averageRating"
              data-test="vendorListingPdtAverageRating"
              id="vendorListingPdtAverageRating"
            >{{getSelectedProduct[0].review.averageRating}}</div>
          </div>
        </div>
        <div class="vendor-listing-wrapper-phone">
          <div class="vendor-listing-a-wrapper">
            <div
              class="vendor-listing-a-item"
              v-for="(vendor, index) in getSelectedProduct[0].vendor_product_inventories"
              :key="index"
            >
              <div class="top">
                <div class="price-a">
                  <p :data-test="'vendorListingPdtVendorPrice'+index"
																					:id="'vendorListingPdtVendorPrice'+index">
                    {{(vendor.promotional_prices &&
                    vendor.promotional_prices.length > 0)?
                    vendor.promotional_prices[0].promotion_applied_price:
                    vendor.price | currencyConversion
                    }}
                  </p>
                </div>
                <div class="seller-details-a">
                  <span :data-test="'vendorListingPdtVendorName'+index"
																								:id="'vendorListingPdtVendorName'+index">{{vendor.vendor_name}}</span>
                </div>
              </div>
              <div class="bottom">
                <div class="delivery-a">
                  <p :data-test="'vendorListingPdtVendorCharge'+index"
																					:id="'vendorListingPdtVendorCharge'+index">
                    Charge:
                    <b :data-test="'vendorListingPdtVendorFree'+index"
																							:id="'vendorListingPdtVendorFree'+index">Free</b>
                  </p>
                  <!--<p>-->
                  <!--Arrives between-->
                  <!--<b>July 06 - 10</b>-->
                  <!--</p>-->
                </div>
                <div class="buying-opt">
                  <cart-action
                    :is-add-to-cart="true"
                    :is-buy-now="false"
                    :pdp="true"
                    :fav="true"
                    :product="getSelectedProduct[0]"
                    :vendor-id="vendor.vendor_id"
                    v-if="vendor.available_stock && vendor.available_stock > 0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vendor-listing-wrapper-desktop">
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col" data-test="vendorListingTitle1"
																				id="vendorListingTitle1">Seller</th>
                <th scope="col" data-test="vendorListingTitle2"
																				id="vendorListingTitle2">Delivery</th>
                <th scope="col" data-test="vendorListingTitle3"
																				id="vendorListingTitle3">Price</th>
                <th scope="col" data-test="vendorListingTitle4"
																				id="vendorListingTitle4">Buying options</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(vendor, index) in getSelectedProduct[0].vendor_product_inventories"
                :key="index"
                :data-test="'vendorListingVendorInventories'+index"
                :id="'vendorListingVendorInventories'+index"
              >
                <th scope="row">
                  <div class="seller-details-a">
                    <span
                      :data-test="'vendorListingVendorInventoriesName'+index"
                      :id="'vendorListingVendorInventoriesName'+index"
                    >{{vendor.vendor_name}}</span>
                  </div>
                </th>
                <td>
                  <div class="delivery-a">
                    <p :data-test="'vendorListingVendorInventoriesCharge'+index"
																							:id="'vendorListingVendorInventoriesCharge'+index">
                      Charge:
                      <b :data-test="'vendorListingVendorInventoriesFree'+index"
																									:id="'vendorListingVendorInventoriesFree'+index">Free</b>
                    </p>
                    <!--<p>-->
                    <!--Arrives between-->
                    <!--<b>July 06 - 10</b>-->
                    <!--</p>-->
                  </div>
                </td>
                <td>
                  <div class="price-a">
                    <p :data-test="'vendorListingVendorPromotionalPrice'+index"
																							:id="'vendorListingVendorPromotionalPrice'+index">
                      {{(vendor.promotional_prices &&
                      vendor.promotional_prices.length > 0)?
                      vendor.promotional_prices[0].promotion_applied_price:
                      vendor.price | currencyConversion
                      }}
                    </p>
                  </div>
                </td>
                <td>
                  <div class="buying-opt">
                    <cart-action
                      :is-add-to-cart="true"
                      :is-buy-now="false"
                      :pdp="true"
                      :fav="true"
                      :product="getSelectedProduct[0]"
                      :vendor-id="vendor.vendor_id"
                      v-if="vendor.available_stock && vendor.available_stock > 0"
                    />
                    <div v-else class="pl-2">
                    <button type="button"
                            class="btn btn-sm blue-btn"
                            :disabled="true"
                            :data-test="'vendorListingOutOfStockButton'+index"
                            :id="'vendorListingOutOfStockButton'+index"
                    >
                      Out of Stock
                    </button>
                  </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CartAction from '@/components/actions/cart/CartAction'
import { mapGetters } from 'vuex'

export default {
	components: {
		CartAction
	},
	computed: {
		...mapGetters('productselected', ['getSelectedProduct'])
	}
}
</script>
